export const lightTheme = {
  bottombar: "#000",
  primary: "#427aaf",
  accent: "#ff8e00",
  secondary: "#EC6906",
  tertiary: "#4b39ee",
  quaternary: "#44AF42",
  quinary: "#f1b202",
  success: "#4CAF50",
  info: "#2e8ac0",
  warning: "#ff8e00",
  error: "#ff5252",
  disabled: "#CCC",
  background: "#ffffff",
  jobstatus_forecast_color: "#8ba631",
  jobstatus_new_color: "#49d99c",
  jobstatus_planned_color: "#daaa3f",
  jobstatus_drive_color: "#c96198",
  jobstatus_in_progress_color: "#8256d0",
  jobstatus_waiting_color: "#cc6b2c",
  jobstatus_completed_color: "#316DCA",
  jobstatus_warranty_color: "#cc6b2c",
  jobstatus_approved_color: "#44AF42",
  jobstatus_closed_color: "#969696",
};

export const legacyVuetifyOptions = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: lightTheme,
    },
  },
};
